import Swal from "sweetalert2";
import { FormType, UserType, useQueryApiError } from "../types";
import { UseMutateFunction, useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { lockUserService } from "../services/lockUser";
import { hasMatchFIF } from "../utils/sbifMatcher";

type LockParams = {
  action: string;
  form: FormType;
  currentUser: UserType;
};

export const handleLock = async ({ action, form, currentUser }: LockParams): Promise<unknown> => {
  const { email, serviceProvider, nroDocumento } = form;
  if (action === "lockPassword") {
    const resultDeleteAccount = await lockUserService({
      userName: hasMatchFIF(serviceProvider) ? nroDocumento : email,
      serviceProvider,
      currentUser
    });
    return resultDeleteAccount;
  }

  return;
};

type LockHookType = {
  mutate: UseMutateFunction<unknown, useQueryApiError, any, () => void>;
  isLoadingAction: boolean;
  isErrorAction: boolean;
  ErrorAction: useQueryApiError | null;
};

export const useLock = (): LockHookType => {
  const navigate = useNavigate();

  const {
    mutate,
    isLoading: isLoadingAction,
    isError: isErrorAction,
    error: ErrorAction
  } = useMutation<unknown, any, any, () => unknown>(handleLock, {
    onSuccess: () => {
      Swal.fire({
        //position: "top",
        icon: "success",
        title: "Has been locked.",
        text: "Lock Success",
        didClose() {
          navigate("/");
        }
      });
    },
    onError: (error) => {
      const resultError = error.response.data.data;

      Swal.fire({
        //position: "top",
        icon: "error",
        title: "Error",
        text: resultError.message
      });
      return resultError;
    }
  });
  return { mutate, isLoadingAction, isErrorAction, ErrorAction };
};
